import React from 'react';
import PropTypes from 'prop-types';

import SelectUser from "core/gd-ui/select-user/select-user";
import FormError from 'src/core/gd-form/common/form-error/form-error';
import ProjectTypeIcon from 'core/gd-components/icons/project-type-icon';
import EventIcon from "../../../../gd-components/icons/event-icon";


export default class ReassignUserProjects extends React.Component {
    static propTypes = {
        form: PropTypes.object,

        projectId: PropTypes.string,
        userId: PropTypes.string,
        projects: PropTypes.array,
    };

    renderProjectsList = () => {
        let res = [];
        _.map(this.props.projects, (p,key)=>{
            const project = gd.session.projects.get(p.id);
            res.push(
                <div key={key} className="row">
                    <div className="cell">
                        <ProjectTypeIcon className="project-icon ui5-ico-13 m-r-10" project={project}/>
                        <div className="ui5-txt-default max-w-300">{project.name}</div>
                    </div>
                </div>
            );
        });

        const userOptions = gd.session.projectUsers.filterByProject(this.props.projectId, gd.const.project.access.FULL).exportToArrayUserId();
        _.remove(userOptions, o=>o === this.props.userId);

        return (
            <React.Fragment>
                <div className="ui5-list h-40">
                    {res}
                </div>

                <div className="ra-to">
                    <div className="lbl">Re-assign to:</div>
                    <SelectUser form={this.props.form}
                                name="projectsReassignTo"
                                renderValue="form-icon-name"
                                options={userOptions} />
                    <div className="lbl"/>
                </div>

                <FormError className="block-error" form={this.props.form} name="projectsReassignTo" />
            </React.Fragment>
        )
    };

    render() {

        if (!this.props.projects.length || this.props.projects.length <1) return false;

        // let content;
        //
        // if (this.props.projects.length > 0) {
        //     content = this.renderProjectsList();
        // } else {
        //     content = (
        //         <div className="block disabled ui5-txt-no-accent-small">
        //             No assigned projects found.
        //         </div>
        //     )
        // }

        return (
            <div className="block">
                <div className="ui5-title-small m-t-20 m-b-10">
                    Projects
                </div>
                {this.renderProjectsList()}
            </div>
        )
    }
}